import { BaseApi } from '@/main/baseApi';

import { DMS_MODULE, NAME } from './constants';

class UzaverkaRozpracovanostProvider extends BaseApi {
	constructor() {
		super(DMS_MODULE, NAME);
	}

	uzaverkaRozpracovanosti(filter: Record<string, any>) {
		return this.post(`/${DMS_MODULE}/${NAME}/UzavRozpracovanosti?provozovnaId=${filter.ProvozovnaId}&uzavSporoPrp=${filter.UzavSporoPrp}`);
	}
}

export const apiProvider = new UzaverkaRozpracovanostProvider();
